import apiFetch from '../apiFetch'

export default function (token, filters, columns) {
  let finderParams = { filter: filters, columns: columns }
  return apiFetch({
    endPoint: 'DossierFinder/ManagementDossierSelfSupplyDownload',
    method: 'POST',
    body: finderParams,
    token: token,
    parseBlobAndAssign: true
  })
}
